import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import Container from '../../components/Layout/Container';
import PageTopBanner from '../../components/PageTopBanner';

import { TabsLink } from '../../components/Tab/Tabs';
import { programData } from '../../components/Tab/TabData';

import useScreenSize from '../../hooks/useScreenSize';
import Input from '../../components/TextField/Input';
import Table from '../../components/Table/Table';
import { Button, PageControlBtns } from '../../components/Button/Button';

import Modal, { useToggleModal } from '../../components/Modal/Modal';
import { fetchGet, fetchPut } from '../../hooks/fetch';
import { validateStr } from '../../hooks/useValidate';
import Loading from '../Loading';

export default function CounselInfo() {
	const [isLoading, setIsLoading] = useState(true);
	const [activeTab, setActiveTab] = useState('');

	const handleDataFromChild = (data) => {
		setActiveTab(data);
	};

	const pageName = '1대1 특허상담프로그램(S.T.A.R.T.) 신청';

	const { id } = useParams();
	const [post, setPost] = useState();
	const [password, setPassword] = useState("");

	
	function getApplicantInfo() {
		fetchGet(
			`/counsels/${id}`,
			(json) => {
				setPost(json);
				setIsLoading(false);
			}
		)
	}

	useEffect(() => {
		setIsLoading(true);
		getApplicantInfo();
	}, []);

	const screenSize = useScreenSize();

	const toggleModal = useToggleModal();
	const openCancelModal = () => {
		toggleModal.open({ name: 'application-cancell-dialog' });
	}

	const onChangePw = (e) => {
		setPassword(e.target.value);
	}

	function closeCancelApply() {
		setPassword("");
		toggleModal.close();
	}

function cancelApply() {
	if(!validateStr(password, "비밀번호를")) return;

	fetchPut(
		`/counsels/${id}`,
		"취소",
		{ password },
		() => {
			setPassword("");
			window.location.replace("/counsel/schedule");
		}
	);
}

	return (
		<main id="program-page-wrap">
			<h1 className="sr-only">{`${pageName} 페이지`}</h1>

			<PageTopBanner />

			<Container>
				<TabsLink
					className="sub-page-tab-con"
					tabsData={programData}
					activatedTab={activeTab}
					onTabChange={handleDataFromChild}
				/>

				<div className="page-content">
					<div className="content-top">
						<div>
							<h1 className="title">{pageName}</h1>
						</div>
					</div>

					<div>
						<div className="apply-form-wrap">
							<h2 className="gs-page-sub-title">신청정보</h2>
							<Table caption="신청정보 목록입니다.">
								<colgroup>
									<col style={{ width: screenSize.width > 540 ? '160px' : '100px' }} />
									<col />
								</colgroup>
								<tbody>
									{post !== undefined ?(
										<>
											<tr className="ta-left">
												<th>신청 일시</th>
												<td>{post.appliedDate}</td>
											</tr>
											<tr className="ta-left">
												<th>이용 시간</th>
												<td>{post.usingTime}</td>
											</tr>
											<tr className="ta-left">
												<th>신청 상태</th>
												<td>{post.status}</td>
											</tr>
											<tr className="ta-left">
												<th>신청자</th>
												<td>{post.name}</td>
											</tr>
											<tr className="ta-left">
												<th>휴대폰 번호</th>
												<td>{post.phone}</td>
											</tr>
											<tr className="ta-left">
												<th>이메일</th>
												<td>{post.email}</td>
											</tr>
										</>
									)
									: isLoading ? <Loading /> : (
											<tr>
												<td colSpan={2}>
													<div className="gs-no-con">
														해당 신청정보를 찾을 수 없습니다.
													</div>
												</td>
											</tr>
										)
									}
								</tbody>
							</Table>
						</div>
					</div>

					<PageControlBtns>
						<Link to="./../../schedule" className="gs-btn white">목록으로</Link>
						{post && <Button type="button" onClick={openCancelModal}>신청 취소</Button>}
					</PageControlBtns>
				</div>
			</Container>

			{toggleModal.modal?.name === 'application-cancell-dialog' && (
				<Modal
					ariaLabelledby="application-cancell-dialog"
					handleOpenModal={closeCancelApply}
					className="dialog"
				>
					<Modal.Header>기술사업화지원센터</Modal.Header>
					<Modal.Body className="center">
						<Input.PasswordEye
							id="user-password"
							label="비밀번호를 입력해주세요."
							placeholder="비밀번호를 입력해주세요."
							value={password}
							onChange={onChangePw}
							maxLength={4}
						/>
					</Modal.Body>
					<Modal.Footer>
						<Button type="button" className="gray" onClick={closeCancelApply}>
							<strong>취소</strong>
						</Button>
						<Button
							type="button"
							onClick={cancelApply}
						>
							<strong>확인</strong>
						</Button>
					</Modal.Footer>
				</Modal>
			)}
		</main>
	);
}
